import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { format } from '@dt/fe-utils'
import doProductStyleController from 'controllers/doProductStyleController'
import CashierController from 'controllers/cashierController'
import { doProductMobx, menuMobx, productSaleMobx } from 'restaurant'
import { MultiModify, SingleModify } from '../'
import './index.scss'
import { decorationMobx } from '@mobxStore'
import { filter, sortBy } from '@dt/fe-utils/dist/lodash'
import { SoldoutFoldBar } from '@cps'

interface IProps {
  subsColor?: string; // 不能打包
  hideModifyDiscount?: boolean;
}

const CnModify: FC<IProps> = ({ subsColor, hideModifyDiscount }) => {
  useEffect(() => {
    // 计算规格口味样式
    doProductStyleController.initWidthWrap()
  }, [doProductMobx.doProduct.modifierGroups])

  return (
    <div className='choose-modify-list'>
      {
        (doProductMobx.doProduct.modifierGroups || []).map(group => {
          let choosedName = ''
          if (group.selectMax === 1) {
            if (group.selectMin === 0) {
              choosedName = i18n.t('productdetail.optional', { count: group.selectMax })
            } else {
              choosedName = i18n.t('modifier.mustSelect')
            }
          } else if (group.selectMin > 0) {
            if (group.cnt === 0) {
              choosedName = i18n.t('modifier.selectMulit', { min: group.selectMin, max: group.selectMax })
            }
          }
          return group.mode === 'multi' ? (
            <MultiModify key={group.no} group={group} subsColor={subsColor} />
          ) : (
            <SingleModify key={group.no} group={group} subsColor={subsColor} />
          )
        })
      }
    </div>
  )
}

export default observer(CnModify)
